import stationMapJson from './station-map.json';

interface StationMapByStationEntry {
    code: number;
    codeName: string;
    stationName: string;
}

export type EsfStationLookup = {
    resortCode: number;
    resortName: string;
    stationName: string;
};

const byStationId = (stationMapJson as { byStationId: Record<string, StationMapByStationEntry> }).byStationId;

export function findEsfByStationId(stationId: number | string): EsfStationLookup | null {
    const entry = byStationId[String(stationId)];
    if (!entry?.code) return null;
    return {
        resortCode: entry.code,
        resortName: entry.codeName,
        stationName: entry.stationName,
    };
}
